import { TabsContent, TabsList, TabsTrigger } from "../../../components/tailwindComponent/ui/tabs";
import { getCategoryStyles } from "../../../utils/utils";
import { BestPracticeCategory } from "./BestPracticeCategory";

interface BestPracticeTabsProps {
  categories: any[];
  activeTab: string;
  detailedSimulations: any;
}

export function BestPracticeTabs({ categories, detailedSimulations }: BestPracticeTabsProps) {
  return (
    <>
      <TabsList className="grid w-full grid-cols-5 rounded-lg p-0 mb-3">
        {categories.map(category => {
          const CategoryIcon = category.icon;
          const styles = getCategoryStyles(category.color);

          return (
            <TabsTrigger
              key={category.id}
              value={category.id}
              className={`
          rounded-md transition-colors duration-200 
          data-[state=active]:bg-card 
          data-[state=active]:text-white
          bg-gray-50
          hover:bg-gray-100
          p-1
        `}
            >
              <div className={`p-1 rounded ${styles.background} data-[state=active]:bg-white`}>
                <CategoryIcon className={`h-5 w-5 ${styles.icon}`} />
              </div>
              <span className="hidden sm:inline text-lg ml-1">{category.title}</span>
            </TabsTrigger>
          );
        })}
      </TabsList>

      {categories.map(category => (
        <TabsContent key={category.id} value={category.id} className="mt-1">
          <BestPracticeCategory category={category} detailedSimulations={detailedSimulations} />
        </TabsContent>
      ))}
    </>
  );
}
